import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface IProps {
	changeNameOfModifier: (value: string) => void;
}

export const NameModifierInput: React.FC<IProps> = React.memo(({ changeNameOfModifier }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterModifierName') }], [t]);

	return (
		<FormInput
			testId="NameModifierInput"
			name="nameOfModifier"
			label="nameModifierLabel"
			onChange={changeNameOfModifier}
			validationRules={validationRules}
			maxLength={100}
		/>
	);
});
